import moment from 'moment';
import { Spinner } from '../../../commonComponents/Spinner';
import { useParams } from 'react-router-dom';
import { TabViewContainer } from '../../../commonComponents/TabViewContainer';
import { useGoTuFeedback } from './hooks';

export const GoTuFeedback = () => {
  const { id } = useParams();

  const { data, isEmpty, isLoading } = useGoTuFeedback(id);

  return (
    <TabViewContainer
      className="profile-tab-item"
      style={{
        alignItems: 'center',
        width: '80%',
      }}
      title="GoTu Feedback"
      variant="card"
    >
      <table>
        <thead>
          <tr>
            <th style={style.th}>Feedback Date</th>
            <th style={style.th}>Platform Used</th>
            <th style={style.th}>GoTu Rating</th>
            <th style={style.th} width="50%">
              Written Feedback
            </th>
          </tr>
        </thead>
        <tbody>
          {isLoading && (
            <tr>
              <td colSpan={4}>
                <Spinner />
              </td>
            </tr>
          )}
          {isEmpty && (
            <tr>
              <td colSpan={4}>No Feedback Found</td>
            </tr>
          )}
          {!isLoading &&
            !isEmpty &&
            data.map(({ createdAt, deviceType, rating, ratingDesc, feedbackNotes }) => (
              <tr key={createdAt}>
                <td style={style.td}>{moment(createdAt).format('ddd, MMM DD, YYYY')}</td>
                <td style={style.td}>{deviceType || '-'}</td>
                <td style={style.td}>
                  {rating}-{ratingDesc}
                </td>
                <td style={style.td}>{feedbackNotes || '-'}</td>
              </tr>
            ))}
        </tbody>
      </table>
    </TabViewContainer>
  );
};

const style = {
  th: {
    fontSize: 13,
    fontWeight: 600,
    textAlign: 'left',
  },
  td: {
    fontSize: 13,
    textAlign: 'left',
  },
};
